// extracted by mini-css-extract-plugin
export default {"container":"PositionsSection_container__CZGT9","title":"PositionsSection_title__IPKfR","dropdowns":"PositionsSection_dropdowns__Za8S5","label":"PositionsSection_label__CNLOf"};